import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import { utcToReport24, utcToLocal, getTimeSpanToNow } from "../../../utils/dateConvert";
import { rounding, getFriendlyHeading } from "../../../utils/math";

class TrackSummary extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      time: Date.now(),
    };
  }

  componentDidMount() {
    // Trigger an update once per second
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.time !== nextState.time;
  }

  handleGsm = (value) => {
    return value ? "Online" : "Offline";
  };

  handleGps = (value) => {
    return value == "A" ? "Online" : "Offline";
  };

  handleFridge = (value) => {
    return value ? "On" : "Off";
  };

  render() {
    let data = this.props.trackDataTotal[0] || {};
    let lastMessage = data.lastMessage || {};
    let gPRMC = lastMessage.gPRMC || {};

    return (
      <div className="summary">
        <div class="subHeading">
          <h1>
            <i className="fa fa-bar-chart"></i> Reported
          </h1>
        </div>

        <div className="summaryBody">
          <div className="summaryBodyContent">
            <Row>
              <Col>
                <span className="inlineDetail">
                  <i className="fa fa-envelope-o" />
                  <span className="gray"> Send:</span>{" "}
                  {utcToLocal(lastMessage.created)}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-envelope-open-o" />
                  <span className="gray"> Received:</span>{" "}
                  {utcToLocal(lastMessage.received)}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-signal text-primary" />
                  <span className="gray"> GSM:</span>{" "}
                  {this.handleGsm(lastMessage.gprsOnline)}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-globe text-primary" />
                  <span className="gray"> GPS:</span>{" "}
                  {this.handleGps(gPRMC.validity)}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-check text-success" />
                  <span className="gray"> Status:</span>{" "}
                  {data.status}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-location-arrow" />
                  &nbsp;{gPRMC.latitude}, {gPRMC.longitude}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-map-marker trackMarker" />
                  &nbsp;{" "}
                  {lastMessage.location}
                </span>
                <br />
              </Col>

              <Col>
                <span className="inlineDetail">
                  {lastMessage.iO3 == 1 ? (<span className="engine-driving" title="Driving">D</span>) : (<span className="engine-park" title="Parked">P</span>)}
                  {getTimeSpanToNow(data.lastStatusChange)}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-tachometer" />
                  <span className="gray"> Speed:</span>{" "}
                  {rounding(gPRMC.speed)}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-truck text-primary" />
                  <span className="gray"> Trip count:</span>{" "}
                  {lastMessage.tripCount}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-road" />
                  <span className="gray"> Odometer:</span>{" "}
                  {lastMessage.odometer}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-compass" />
                  <span className="gray"> Heading:</span>{" "}
                  {getFriendlyHeading(gPRMC.heading, true)}
                </span>
                <br />
              </Col>

              <Col>
                <span className="inlineDetail">
                  <i className="fa fa-snowflake-o" />
                  <span className="gray"> Fridge:</span>{" "}
                  {this.handleFridge(lastMessage.iO1)}
                </span>
                <br />
                {lastMessage && (
                    <React.Fragment>
                      <span className="inlineDetail">
                        <i className="fa fa-thermometer-full text-warning" />
                        <span className="gray"> Temp A:</span>{" "}
                        {lastMessage.sensorAValue}
                      </span>
                      <br />
                    </React.Fragment>
                  )}
                {lastMessage && (
                    <React.Fragment>
                      <span className="inlineDetail">
                        <i className="fa fa-thermometer-full text-primary" />
                        <span className="gray"> Temp B:</span>{" "}
                        {lastMessage.sensorBValue}
                      </span>
                      <br />
                    </React.Fragment>
                  )}
                <span className="inlineDetail">
                  <i className="fa fa-life-ring text-danger" />
                  <span className="gray"> Duress:</span>{" "}
                  {data.lastDuress !== null && (
                    <span className="gray">
                      {" "}
                      {utcToReport24(data.lastDuress)}
                    </span>
                  )}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-plug" />
                  <span className="gray"> Powercut:</span>{" "}
                  {data.lastPowerCut !== null && (
                    <span className="gray">
                      {" "}
                      {utcToReport24(data.lastPowerCut)}
                    </span>
                  )}
                </span>
                <br />
              </Col>

              <Col>
                <span className="inlineDetail">
                  <i className="fa fa-feed" />
                  <span className="gray"> Satellites:</span>{" "}
                  {lastMessage.satellites}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-bolt" />
                  <span className="gray"> Device Volts:</span>{" "}
                  {lastMessage.deviceVolts}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-thermometer-quarter" />
                  <span className="gray"> Device Temp:</span>{" "}
                  {lastMessage.deviceTemp}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-envelope" />
                  <span className="gray"> Log Type:</span>{" "}
                  {lastMessage.messageID}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-sign-in" />
                  <span className="gray"> Last Login:</span> {``}
                  {data.lastLogin ? utcToLocal(data.lastLogin) : ''}
                </span>
                <br />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export default TrackSummary;
